import { render, staticRenderFns } from "./certificado.vue?vue&type=template&id=5f49afcf"
import script from "./certificado.vue?vue&type=script&lang=js"
export * from "./certificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports